import React from 'react';
import { useTranslation } from 'react-i18next';
import './ConnectUs.css';
import { useDocumentTitle } from './hooks/useDocumentTitle';
import contactConfig from './config/contactConfig.json';

const ConnectUs = () => {
  const { t } = useTranslation();
  useDocumentTitle('connectUs');
  
  return (
    <div className="connect-us-container">
      <div className="connect-us-header">
        <div className="connect-us-header-content">
          <h1>{t('connectUs.title')}</h1>
          <p className="header-subtitle">{t('connectUs.subtitle')}</p>
        </div>
      </div>

      <div className="connect-us-content">
        <div className="contact-section">
          <div className="contact-card">
            <div className="card-icon">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z" fill="currentColor"/>
              </svg>
            </div>
            <h2>{t('connectUs.contactInfo.title')}</h2>
            <p className="card-description">{t('connectUs.contactInfo.description')}</p>
            <div className="contact-details">
              <p><strong>{t('connectUs.contactInfo.email')}:</strong> {contactConfig.contactInfo.email}</p>
            </div>
          </div>

          <div className="contact-card">
            <div className="card-icon">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16Z" fill="currentColor"/>
              </svg>
            </div>
            <h2>{t('connectUs.careers.title')}</h2>
            <p className="card-description">{t('connectUs.careers.description')}</p>
            <div className="contact-details">
              <p style={{ whiteSpace: 'pre-line' }}>{t('connectUs.careers.content')}</p>
              <p><strong>{t('connectUs.careers.email')}:</strong> {contactConfig.careers.email}</p>
              {/* <button className="action-button">{t('connectUs.careers.viewOpenings')}</button> */}
            </div>
          </div>

          <div className="contact-card">
            <div className="card-icon">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM9 17H7V10H9V17ZM8 8.99C7.17 8.99 6.5 8.32 6.5 7.49C6.5 6.66 7.17 5.99 8 5.99C8.83 5.99 9.5 6.66 9.5 7.49C9.5 8.32 8.83 8.99 8 8.99ZM17 17H15V13.5C15 12.12 13.38 12.25 13.38 13.5V17H11.38V10H13.38V11.12C14.26 9.47 17 9.32 17 12.38V17Z" fill="currentColor"/>
              </svg>
            </div>
            <h2>{t('connectUs.media.title')}</h2>
            <p className="card-description">{t('connectUs.media.description')}</p>
            <div className="contact-details">
              <p>{t('connectUs.media.content')}</p>
              <p><strong>{t('connectUs.media.email')}:</strong> {contactConfig.media.email}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConnectUs;
